export default "__VITE_ASSET__CAA2GR$y__"